module.exports = __webpack_public_path__ + "assets/img/hardware.a1193c90.svg";